import ObjectUtils from './object.utils';
import DateUtils from './date.utils';

const Utils = {
    ...ObjectUtils,
    ...DateUtils,
}

export default Utils;